export default __webpack_public_path__ + "static/media/group-808080.8da75595.svg";